import { useActivitySummaryContext } from '../../../context'

export function useData() {
  const [
    {
      activeTab,
      tableState: { loading },
    },
  ] = useActivitySummaryContext()

  return {
    loading,
    activeTab,
  }
}
